// import { Swipe } from '../components/swipe';

export default {

  init() {
    // console.log(Swipe);
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },

};



// WEBPACK FOOTER //
// ./scripts/routes/unit.js